import React from 'react';

export const defaultIntlValueResolvers = {
  b: (string: string) => <b>{string}</b>,
  br: () => <br />,
  i: (string: string) => <i>{string}</i>,
};
